export type CoaAccount = { id: string; name?: string; number?: number; isDefault?: boolean };

export const findCoaAccount = (accounts: CoaAccount[] | undefined, id?: string | number, name?: string): CoaAccount | undefined => {
  if (!accounts?.length) return undefined;
  if (id != null) {
    const byId = accounts.find((a) => a.id === String(id));
    if (byId) return byId;
  }
  if (name) {
    const lower = String(name).toLowerCase();
    return accounts.find((a) => a.name?.toLowerCase() === lower);
  }
  return undefined;
};

export const formatCoaName = (
  accounts: CoaAccount[] | undefined,
  t: (key: string) => string,
  id?: string | number,
  name?: string
): string => {
  if (!name) return '';
  const matched = findCoaAccount(accounts, id, name);
  return matched?.isDefault ? t(String(name)) : String(name);
};

export const formatKnownCoaLabel = (account: CoaAccount | undefined, t: (key: string) => string): string => {
  if (!account) return '';
  const displayName = account.name ? (account.isDefault ? t(String(account.name)) : String(account.name)) : '';
  if (account.number != null && displayName) {
    return `${account.number} - ${displayName}`;
  }
  return account.number != null ? String(account.number) : displayName;
};

export const formatCoaLabel = (accounts: CoaAccount[] | undefined, t: (key: string) => string, id?: string | number, name?: string) => {
  const matched = findCoaAccount(accounts, id, name);
  const targetNumber = matched?.number;
  const displayName = formatCoaName(accounts, t, id, name);
  if (targetNumber != null && displayName) {
    return `${targetNumber} - ${displayName}`;
  }
  return targetNumber != null ? String(targetNumber) : displayName;
};
